module.exports = __webpack_public_path__ + "img/camphest_logo_large_widest.ddda74a5.jpg";